import { global } from "../../constants";

export const data = {
  banner: {
    base: "Services",
    background: global.banner + "4k.jpg",
    title: "Insurance",
    crumb: "Insurance",
  },
  icon: "fa-solid fa-shield-halved",
  shortDescription:
    "Determination and placement of coverages and bonds necessary to protect assets, logistics operations, and staff well-being, with tailored solutions for the maritime and foreign trade sector.",
  title: "Insurance",
  features: {
    title: "Insurance",
    deliverables: "Deliverables",
    reqDocuments: "Required Documents",
    subtitle:
      "Coverage for vessels, cargo, containers, contractual guarantees, and personal/corporate programs tailored to maritime and foreign trade operations.",
    description: `We design and place asset insurance programs (H&M, P&I, civil liability, cargo, and containers) and personal insurance (health, life, travel, disability), as well as tailored bonds and trusts. Our approach integrates risk assessment, contracting, issuance, and claims management to minimize financial exposure and ensure operational continuity.`,
    viewDetail: "View Details",
    feats: [
      {
        key: "hull_machinery",
        title: "Hull & Machinery (H&M)",
        summary:
          "Coverage for hull, machinery, and onboard equipment, including damage from survey, collision, and common maritime risks.",
        details:
          "H&M program designed for commercial, fishing, or auxiliary vessels: assessment of insured amount, exclusions, deductibles, and specific clauses for international navigation. Includes advice on insurance clauses, damage assessment, and coordination with marine adjusters.",
        deliverables: [
          "H&M Policy Proposal (terms and premiums)",
          "Analysis of insured amounts and recommendations",
          "Procedure for claim declaration and management"
        ],
        requiredDocs: [
          "Vessel technical sheet (length, year, flag)",
          "Maintenance history and previous claims",
          "Safety certificates and registration documents"
        ],
        icon: "fa-solid fa-ship",
        image: global.services + "insurance/1.webp",
      },
      {
        key: "pandi",
        title: "P&I — Protection & Indemnity",
        summary:
          "Civil liability coverage for shipowners and operators: claims for third-party damages, pollution, crew liability, and cargo claims.",
        details:
          "We advise on admission to P&I clubs or equivalent schemes, establishment of retentions, and coordination in claims. We define scope regarding pollution, passage through locks/ports, and liability for cargo or third-party damages.",
        deliverables: [
          "Assessment of P&I needs",
          "Management of membership/renewal and coverage letter",
          "Protocol for handling P&I claims"
        ],
        requiredDocs: [
          "Tonnage and operations details",
          "Claims history",
          "Previous policies and P&I certificates if any"
        ],
        icon: "fa-solid fa-hand-holding-water",
        image: global.services + "insurance/2.webp",
      },
      {
        key: "responsabilidad_civil",
        title: "Civil Liability and Special Risks",
        summary:
          "General and limited civil liability coverage for port operations, logistics, and related activities; inclusion of special risks depending on the operation.",
        details:
          "We design civil liability policies for companies (including service location, customs agents, general warehouse operators, and logistics operators). We assess coverage needs for third-party damages, pollution, professional liability, and special risks (malicious acts, theft, political risks if applicable).",
        deliverables: [
          "Civil liability policy proposal with limits and exclusions",
          "Coverage gap analysis",
          "Recommended clauses for contracts with third parties"
        ],
        requiredDocs: [
          "Description of activities and operations",
          "Contracts with clients/suppliers",
          "Claims and contingency history"
        ],
        icon: "fa-solid fa-gavel",
        image: global.services + "insurance/3.webp",
      },
      {
        key: "carga_multimodal",
        title: "Cargo Coverage — Maritime, Land, and Air",
        summary:
          "Policies to protect goods at all stages: maritime, land, and air transport (all risk / named risk).",
        details:
          "We design cargo programs for imports and exports, including multimodal transport, coverage for loss, damage, theft, and logistics contingencies. Consolidation, transshipment, and temporary storage clauses in warehouses are considered.",
        deliverables: [
          "Cargo policy conditions for each mode",
          "Estimated premium table by type of goods",
          "Procedure for policy issuance and endorsements"
        ],
        requiredDocs: [
          "List of goods and commercial value",
          "Route and operator information",
          "Shipping documents (BL, AWB, guides)"
        ],
        icon: "fa-solid fa-boxes-stacked",
        image: global.services + "insurance/4.webp",
      },
      {
        key: "contenedores",
        title: "Containers — In Transit and Port Yard",
        summary:
          "Specific coverage for containers while in transit or stored in port yards/terminals, including loss, damage, and vandalism.",
        details:
          "We offer policies and specific clauses for full or empty containers, with extension for damage from handling, storage in yards, and liability coverage to third parties. Includes options for unit and fleet insurance, as well as adjustments according to yard period.",
        deliverables: [
          "Container insurance proposal (unit/fleet)",
          "Endorsements for yard and transit coverage",
          "Checklist for declaration and documentation"
        ],
        requiredDocs: [
          "List of containers and status",
          "Contracts with terminals and operators",
          "Loss/damage history"
        ],
        icon: "fa-solid fa-box",
        image: global.services + "insurance/5.webp",
      },
      {
        key: "fianzas_garantias",
        title:
          "Bonds and Guarantees — Bid Maintenance, Faithful Performance, and Advance",
        summary:
          "Issuance and management of bonds for tenders, operational contracts, and customs obligations; guarantees for customs agents, warehouses, and suppliers.",
        details:
          "We manage bank guarantees and bonds for bid maintenance, faithful performance, labor advance, temporary admission, and fines. We advise on the most suitable type of bond, issuance requirements, terms, and management of claims against the bond.",
        deliverables: [
          "Bond/guarantee proposal as needed",
          "Support in documentation for issuance",
          "Monitoring and management of the bond until expiration"
        ],
        requiredDocs: [
          "Tender conditions or contract",
          "Applicant's financial documentation",
          "Specifications of amount and guarantee period"
        ],
        icon: "fa-solid fa-file-shield",
        image: global.services + "insurance/6.webp",
      },
      {
        key: "fideicomiso",
        title: "Tailored Trusts for the Client",
        summary:
          "Fiduciary structure for fund management, guarantees, and asset security linked to foreign trade operations or specific projects.",
        details:
          "We design trusts to secure contractual obligations, manage guarantee funds, administer project resources, or serve as escrow mechanisms in asset purchase and sale operations. Includes drafting of trust deed, selection of trustee, and parameterization of fund release rules.",
        deliverables: [
          "Trust scheme proposal",
          "Draft of trust deed",
          "Operational guide for trustee and beneficiaries"
        ],
        requiredDocs: [
          "Purpose and amount of the trust",
          "Data of parties and beneficiaries",
          "Legal documentation of assets to be entrusted"
        ],
        icon: "fa-solid fa-hand-holding-dollar",
        image: global.services + "insurance/7.webp",
      },
      {
        key: "seguros_personales",
        title: "Personal and Corporate Insurance",
        summary:
          "Health, life, travel assistance, and disability coverage programs designed for employees and executives in LATAM and USA.",
        details:
          "We offer individual and group policies: health insurance (local and regional plans), life insurance for Latin America and specific coverage for the USA, international travel assistance, temporary or permanent disability insurance, and solutions for occupational risks and special exposures. Includes benefit analysis, estimated premium, and coinsurance options.",
        deliverables: [
          "Benefit plan proposal (individual/corporate)",
          "Coverage and premium comparison",
          "Instructions for enrollment and claims"
        ],
        requiredDocs: [
          "List of employees/beneficiaries",
          "Basic medical data (as per insurer)",
          "Specific needs and required scope"
        ],
        icon: "fa-solid fa-user-shield",
        image: global.services + "insurance/8.webp",
      },
      {
        key: "gestion_siniestros",
        title: "Claims Management and Prevention",
        summary:
          "Comprehensive assistance in claims handling: declaration, adjustment, negotiation, and closure; as well as preventive programs to reduce occurrence.",
        details:
          "We coordinate the submission of claims, interaction with adjusters and insurers, assessment of expert reports, and negotiation of indemnities. We develop prevention programs, risk audits, and training to reduce the frequency and impact of claims.",
        deliverables: [
          "Claims management protocol",
          "Assistance in processing and tracking claims",
          "Improvement/prevention report after claim"
        ],
        requiredDocs: [
          "Claim reports and incidents",
          "Contractual documentation and policies",
          "Expert reports and photographic evidence"
        ],
        icon: "fa-solid fa-file-medical",
        image: global.services + "insurance/9.webp",
      }
    ],
  },
  ctaText: "Request insurance quote",
  ctaLink: "/contact?service=asset-personal-insurance",
};
